// extracted by mini-css-extract-plugin
module.exports = {"analytics":"analytics--1IR5b","main":"main--1S4OR","nav":"nav--2NyiO","sidebar":"sidebar--672x_"};